import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Contact.css";
import Header from "../Components/Header";
import { Helmet } from "react-helmet";

const Merci = () => {

  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-17898913995/1JkWCPSU4PMbEMuB79ZC'
      });
    }
  }, []);

  return (
    <>
      <Header title={""} />
      <Helmet>
        <title>Merci</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div
        className="container text-center"
        style={{ marginBottom: "18.74%", marginTop: "2%" }}
      >
        <h1>Merci</h1>
        <p>Votre message a bien été envoyé. Nous vous recontacterons rapidement.</p>
      </div>
    </>
  );
};

export default Merci;